import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { config } from '_config';

export default function OfficeActionStep3({ state, onChange, validated }) {

  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        {config.skin === 'v2-basic' && <h2>New specimen</h2>}
        <div className="polaroid">
        <p className="primary-label">Do you need to submit a new specimen as part of this office action?</p>
        <div key={`inline-radio`} className="mb-3">
          <Form.Check
            inline
            label="Yes"
            name="needsSpecimen"
            type="radio"
            id="needsSpecimen1"
            value={"yes"}
            checked={state.needsSpecimen === "yes"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="No"
            name="needsSpecimen"
            id="needsSpecimen2"
            type="radio"
            value={"no"}
            checked={state.needsSpecimen === "no"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="I don't know"
            name="needsSpecimen"
            id="needsSpecimen3"
            type="radio"
            value={"know"}
            checked={state.needsSpecimen === "know"}
            onChange={handleChange}
          />
        </div>
        </div>
        {state.needsSpecimen === "yes" ?         <div className="polaroid">
        <p className="primary-label">* Please specify class type for specimen as part of this office action.</p>
        <div key={`inline-radio`} className="mb-3">
          <Form.Check
            inline
            label="Goods"
            name="goodsOrService"
            type="radio"
            id="goodsOrService1"
            value={"GOODS"}
            checked={state.goodsOrService === "GOODS"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="Service"
            name="goodsOrService"
            id="goodsOrService2"
            type="radio"
            value={"SERVICE"}
            checked={state.goodsOrService === "SERVICE"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="Both"
            name="goodsOrService"
            id="goodsOrService3"
            type="radio"
            value={"BOTH"}
            checked={state.goodsOrService === "BOTH"}
            onChange={handleChange}
          />
        </div>
        </div> : ""}
      </div>
    </Form>
  );
}
